<template>
  <div class="card shadow bg-secondary">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right" v-show="lvl === '999'">
          <base-button type="danger" size="sm" @click="deleteWSU"
            >ลบข้อมูล</base-button
          >
        </div>
      </div>
    </div>

    <div class="card-body pt-0 pt-md-4">
      <h6 class="heading-small text-muted mb-4">บันทึกข้อมูลกรมธรรม์</h6>
      <div class="row">
        <div class="col-12 col-md-3">
          <base-input
            alternative=""
            label="กรมธรรมเลขที่"
            placeholder="กรมธรรมเลขที่"
            input-classes="form-control-alternative"
            v-model="model.policy_number"
            @input="
              (v) => {
                model.policy_number = v.toUpperCase();
              }
            "
          />
        </div>
        <div class="col-12 col-md-3">
          <h4>ตัวแทน</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedAgent !== -1
                  ? masterAgent[selectedAgent].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(agent, index) in masterAgent"
                :key="agent.id"
                :value="agent.name"
                @click="selectAgent(agent.id, index)"
                >{{ agent.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <h4>บริษัท</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedCompany !== -1
                  ? masterCompany[selectedCompany].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(company, index) in masterCompany"
                :key="company.id"
                :value="company.name"
                @click="selectCompany(company.id, index)"
                >{{ company.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div>
            <label for="file" class="form-control-label"
              >อัพโหลดไฟล์กรมธรรม์</label
            >
          </div>
          <input
            type="file"
            id="file"
            name="file"
            ref="file"
            accept="image/pdf, image/png , image/jpg , image/jpeg"
            @change="onFileChange"
          />
        </div>
      </div>
      <h6 class="heading-small text-muted mb-4 mt-4">รายละเอียดลูกค้า</h6>
      <div class="row">
        <div class="col-md-2">
          <base-input
            alternative=""
            label="คำนำหน้า"
            placeholder="คำนำหน้า"
            input-classes="form-control-alternative"
            v-model="model.name_prefix"
          />
        </div>
        <div class="col-md-6">
          <base-input
            alternative=""
            label="ชื่อ-นามสกุล"
            placeholder="ชื่อ-นามสกุล"
            input-classes="form-control-alternative"
            v-model="model.name"
          />
        </div>
        <div class="col-md-4">
          <base-input
            alternative=""
            label="เลขที่บัตรประจำตัว/เลขจดทะเบียนบริษัท"
            type="number"
            placeholder="เลขที่บัตรประจำตัว/เลขจดทะเบียนบริษัท"
            input-classes="form-control-alternative"
            v-model="model.identity_no"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12  col-md-9">
          <base-input
            alternative=""
            label="ที่อยู่"
            placeholder="ที่อยู่"
            input-classes="form-control-alternative"
            v-model="model.address"
          />
        </div>
        <div class="col-12 col-md-3">
          <base-input
            alternative=""
            label="เบอร์โทรศัพท์"
            type="number"
            placeholder="เบอร์โทรศัพท์"
            input-classes="form-control-alternative"
            v-model="model.tel"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <h4>จังหวัด</h4>
                    <v-select
            v-model="model.province"
            :options="masterProvince"
            :reduce="(p) => p.id"
            label="name"
            @input="changedLabel"
          ></v-select>
          <!-- <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedProvince !== -1
                  ? masterProvince[selectedProvince].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(province, index) in masterProvince"
                :key="province.id"
                :value="province.name"
                @click="selectProvince(province.id, index)"
                >{{ province.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div> -->
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <h4>อำเภอ</h4>
                    <v-select
            v-model="model.district"
            :options="masterDistrict"
            :reduce="(p) => p.id"
            label="name"
          ></v-select>
          <!-- <div class="dropdown w-100">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedDistrict !== -1
                  ? masterDistrict[selectedDistrict].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(district, index) in masterDistrict"
                :key="district.id"
                :value="district.name"
                @click="selectDistrict(district.id, index)"
                >{{ district.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div> -->
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <h4>ตำบล</h4>
          <v-select
            v-model="model.sub_district"
            :options="masterSubDistrict"
            :reduce="(p) => p.id"
            label="name"
          ></v-select>
          <!-- <div class="dropdown w-100">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedSubDistrict !== -1
                  ? masterSubDistrict[selectedSubDistrict].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(subdistrict, index) in masterSubDistrict"
                :key="subdistrict.id"
                :value="subdistrict.name"
                @click="selectSubDistrict(subdistrict.id, index)"
                >{{ subdistrict.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div> -->
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <base-input
            alternative=""
            label="รหัสไปรษณีย์"
            type="number"
            placeholder="รหัสไปรษณีย์"
            input-classes="form-control-alternative"
            v-model="model.postal_code"
          />
        </div>
      </div>
      <h6 class="heading-small text-muted mb-4 mt-4">
        รายละเอียดการเอาประกัน และเบี้ยประกันภัย ภาคบังคับ (พรบ.)
      </h6>
      <div class="row">
        <div class="col-md-3">
          <!-- <h4>วันที่ทำสัญญา</h4>
          <datepicker
            ::lang="th"
            :format="momentFormat"
            class="date-picker"
            v-model="model.contact_start_date"
          ></datepicker> -->
          <base-input
            alternative=""
            label="วันที่ทำสัญญา"
            type="text"
            placeholder="วว/ดด/ปปปป"
            input-classes="form-control-alternative"
            v-model="formattedStartContactDate"
          />
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <!-- <h4>วันที่คุ้มครอง</h4>
          <datepicker
            ::lang="th"
            :format="momentFormat"
            class="date-picker"
            v-model="model.cover_start_date"
          ></datepicker> -->
          <base-input
            alternative=""
            label="วันที่คุ้มครอง"
            type="text"
            placeholder="วว/ดด/ปปปป"
            input-classes="form-control-alternative"
            v-model="formattedStartCoverDate"
          />
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <!-- <h4>ถึง</h4>
          <datepicker
            ::lang="th"
            :format="momentFormat"
            class="date-picker"
            placeholder="คลิกเพื่อเลือกวัน"
            v-model="model.cover_end_date"
          ></datepicker> -->
          <base-input
            alternative=""
            label="ถึง"
            type="text"
            placeholder="วว/ดด/ปปปป"
            input-classes="form-control-alternative"
            v-model="formattedEndCoverDate"
          />
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <base-input
            alternative=""
            label="จำนวนวันคุ้มครอง"
            type="number"
            placeholder="จำนวนวันคุ้มครอง"
            input-classes="form-control-alternative"
            :value="calculateDateDiff"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-3">
          <!-- <h4>วันครบกำหนดภาษี</h4>
          <datepicker
            :lang="th"
            :format="momentFormat"
            class="date-picker"
            placeholder="คลิกเพื่อเลือกวัน"
            v-model="model.tax_due_date"
          ></datepicker> -->
          <base-input
            alternative=""
            label="วันครบกำหนดภาษี"
            type="text"
            placeholder="วว/ดด/ปปปป"
            input-classes="form-control-alternative"
            v-model="formattedTaxDueDate"
          />
        </div>
        <div class="col-12 col-md-2 mt-3 mt-md-0">
          <h4>ยี่ห้อ</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedBrand !== -1
                  ? masterBrand[selectedBrand].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(brand, index) in masterBrand"
                :key="brand.id"
                :value="brand.name"
                @click="selectBrand(brand.id, index)"
                >{{ brand.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-12 col-md-2 mt-3 mt-md-0">
          <h4>การใช้รถ</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedCarType !== -1
                  ? masterCarType[selectedCarType].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(carType, index) in masterCarType"
                :key="carType.id"
                :value="carType.name"
                @click="selectCarType(carType.id, index)"
                >{{ carType.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-12 col-md-2 mt-3 mt-md-0">
          <base-input
            alternative=""
            label="เลขทะเบียน"
            placeholder="เลขทะเบียน"
            input-classes="form-control-alternative"
            v-model="model.license_plate"
          />
        </div>
        <div class="col-12 col-md-3">
          <h4>จังหวัด</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedLicensePlateProvince !== -1
                  ? masterProvince[selectedLicensePlateProvince].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(province, index) in masterProvince"
                :key="province.id"
                :value="province.name"
                @click="selectLicensePlateProvince(province.id, index)"
                >{{ province.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-6">
          <base-input
            alternative=""
            label="เลขตัวถัง"
            placeholder="เลขตัวถัง"
            input-classes="form-control-alternative"
            v-model="model.body_number"
            @input="
              (v) => {
                model.body_number = v.toUpperCase();
              }
            "
          />
        </div>
        <div class="col-md-3 col-6">
          <h4>แบบตัวถัง</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedBodyType !== -1
                  ? masterBodyType[selectedBodyType].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(bodyType, index) in masterBodyType"
                :key="bodyType.id"
                :value="bodyType.name"
                @click="selectBodyType(bodyType.id, index)"
                >{{ bodyType.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <base-input
            alternative=""
            label="อื่นๆ"
            placeholder="โปรดระบุ"
            :disabled="model.body_type !== 4"
            input-classes="form-control-alternative"
            v-model="model.if_other_body_type"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4 col-6">
          <base-input
            alternative=""
            label="CC"
            placeholder="CC"
            input-classes="form-control-alternative"
            v-model="model.cc"
          />
        </div>
        <div class="col-md-4 col-6">
          <base-input
            alternative=""
            label="ที่นั่ง"
            placeholder="ที่นั่ง"
            input-classes="form-control-alternative"
            v-model="model.seat"
          />
        </div>
        <div class="col-md-4 col-6">
          <base-input
            alternative=""
            label="น้ำหนัก"
            placeholder="น้ำหนัก"
            input-classes="form-control-alternative"
            v-model="model.weight"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6 col-9">
          <base-input
            alternative=""
            label="เบี้ยรวม"
            type="number"
            step="any"
            placeholder="เบี้ยรวม"
            input-classes="form-control-alternative"
            v-model="model.insurance_premium"
          />
        </div>
        <div class="col-md-1 col-3">
          <h3 class="mt-5">บาท</h3>
        </div>
        <div class="col-md-5 col-6 text-left">
          <base-button
            type="primary"
            size="md"
            class="mt-md-4"
            @click="saveWSU"
            :disabled="isSaving"
            >บันทึก</base-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import router from "../router";
import Dropdown from "bootstrap-vue/src/components/dropdown";
import Radio from "bootstrap-vue/src/components/form-radio";
// import Datepicker from "vue2-datepicker";
import moment from "moment";
import kickMixin from "../mixins/kickMixin";

Vue.use(Dropdown);
Vue.use(Radio);

moment.locale("th");

export default {
  name: "edit-wsu",
  mixins: [kickMixin],
  // components: {
  //   Datepicker,
  // },
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      isFirstTimeLoadProvince: true,
      isFirstTimeLoadDistrict: true,
      isFirstTimeLoadSubDistrict: true,
      lvl: "",
      isSaving: false,
      masterBrand: [],
      masterAgent: [],
      masterProvince: [],
      masterDistrict: [],
      masterSubDistrict: [],
      masterBodyType: [],
      masterCarType: [],
      masterCompany: [],
      selectedLicensePlateProvince: -1,
      selectedAgent: -1,
      selectedProvince: -1,
      selectedDistrict: -1,
      selectedSubDistrict: -1,
      selectedBrand: -1,
      selectedBodyType: -1,
      selectedCarType: -1,
      selectedCompany: -1,
      date1: "",
      date2: "",
      date3: "",
      date4: "",
      th: {
        formatLocale: {
          firstDayOfWeek: 1,
          monthsShort: [
            "ม.ค.",
            "ก.พ.",
            "มี.ค.",
            "เม.ย.",
            "พ.ค.",
            "มิ.ย.",
            "ก.ค.",
            "ส.ค.",
            "ก.ย.",
            "ต.ค.",
            "พ.ย.",
            "ธ.ค.",
          ],
          weekdaysMin: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        },
        monthBeforeYear: true,
      },
      momentFormat: {
        stringify: (date) => {
          return date
            ? moment(date)
                .add(543, "y")
                .format("D MMM YYYY")
            : null;
        },
        parse: (value) => {
          return value
            ? moment(value, "D MMM YYYY")
                .subtract(543, "y")
                .toDate()
            : null;
        },
      },
      model: {
        policy_number: "",
        company_id: -1,
        file: "",
        tel: "",
        identity_no: "",
        name_prefix: "",
        name: "",
        address: "",
        license_plate_province: { id: -1, name: "-" },
        province: { id: -1, name: "-" },
        district: { id: -1, name: "-" },
        sub_district: { id: -1, name: "-" },
        postal_code: "",
        contact_start_date: "",
        cover_start_date: "",
        cover_end_date: "",
        tax_due_date: "",
        brand: 0,
        license_plate: "",
        body_number: "",
        car_type: -1,
        body_type: -1,
        if_other_body_type: "",
        cc: "",
        seat: "",
        weight: "",
        agent: -1,
        insurance_premium: "",
      },
    };
  },
  methods: {
    onFileChange() {
      this.model.file = this.$refs.file.files[0];
    },
    loadWSU: function() {
      var localApp = this;
      axios
        .get("/api/wsu/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          localApp.date1 = moment(
            response.data.data.contact_start_date,
            "YYYY-MM-DD HH:MM:SS"
          )
            .add(543, "y")
            .format("DD/MM/YYYY");
          localApp.date2 = moment(
            response.data.data.cover_start_date,
            "YYYY-MM-DD HH:MM:SS"
          )
            .add(543, "y")
            .format("DD/MM/YYYY");
          localApp.date3 = moment(
            response.data.data.cover_end_date,
            "YYYY-MM-DD HH:MM:SS"
          )
            .add(543, "y")
            .format("DD/MM/YYYY");
          localApp.date4 = moment(
            response.data.data.tax_due_date,
            "YYYY-MM-DD HH:MM:SS"
          )
            .add(543, "y")
            .format("DD/MM/YYYY");

          // response.data.data.contact_start_date = moment(
          //   response.data.data.contact_start_date,
          //   "YYYY-MM-DD HH:MM:SS"
          // ).format("DD/MM/YYYY");
          // response.data.data.cover_start_date = moment(
          //   response.data.data.cover_start_date,
          //   "YYYY-MM-DD HH:MM:SS"
          // ).format("DD/MM/YYYY");
          // response.data.data.cover_end_date = moment(
          //   response.data.data.cover_end_date,
          //   "YYYY-MM-DD HH:MM:SS"
          // ).format("DD/MM/YYYY");
          // response.data.data.tax_due_date = moment(
          //   response.data.data.tax_due_date,
          //   "YYYY-MM-DD HH:MM:SS"
          // ).format("DD/MM/YYYY");

          response.data.data.file = "";
          localApp.model = response.data.data;

          //Bind data to dropdown
          localApp.selectedAgent = localApp.masterAgent.findIndex(
            (item) => item.id === localApp.model.agent
          );

          localApp.selectedBrand = localApp.masterBrand.findIndex(
            (item) => item.id === localApp.model.brand
          );

          localApp.selectedCarType = localApp.masterCarType.findIndex(
            (item) => item.id === localApp.model.car_type
          );

          localApp.selectedBodyType = localApp.masterBodyType.findIndex(
            (item) => item.id === localApp.model.body_type
          );

          localApp.selectedCompany = localApp.masterCompany.findIndex(
            (item) => item.id === localApp.model.company_id
          );

          localApp.selectedLicensePlateProvince = localApp.masterProvince.findIndex(
            (item) => item.id === localApp.model.license_plate_province
          );

          localApp.selectedProvince = localApp.masterProvince.findIndex(
            (item) => item.id === localApp.model.province
          );

          localApp.selectProvince(
            localApp.model.province,
            localApp.selectedProvince
          );
        })
        .catch(function() {
          localApp.kick();
        });
    },
    saveWSU: function() {
      var localApp = this;

      if (
        localApp.model.name_prefix !== "" &&
        localApp.model.name !== "" &&
        localApp.model.tel !== "" &&
        localApp.model.cover_end_date !== "" &&
        localApp.model.tax_due_date !== "" &&
        localApp.model.license_plate !== "" &&
        localApp.model.insurance_premium !== ""
      ) {
        localApp.isSaving = true;

        let formData = new FormData();

        for (let [key, value] of Object.entries(localApp.model)) {
          formData.append("_method", "PATCH");
          if (
            key === "cover_end_date" ||
            key === "cover_start_date" ||
            key === "tax_due_date" ||
            key === "contact_start_date"
          ) {
            // value = value.toJSON();
          }
          if (value === null) value = "";
          formData.append(key, value);
        }
        axios
          .post(
            "/api/wsu/" + this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                "Content-Type":
                  "multipart/form-data;boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW",
              },
            }
          )
          .then(function(response) {
            if (response.status == 200) {
              router.push("/customerWsu");
            }
            localApp.isSaving = false;
          })
          .catch(function(error) {
            alert(error);
            localApp.isSaving = false;
          });
      } else {
        alert(
          "กรุณาใส่ ชื่อ, เบอร์โทร, เลขทะเบียน, วันที่ทำสัญญา, วันคุ้มครอง, วันหมดอายุ วันครบภาษี และ เบี้ยรวม"
        );
      }
    },
    deleteWSU: function() {
      if (confirm("เมื่อลบแล้วจะไม่สามารถกู้คืนได้ แน่ใจใช่หรือไม่?")) {
        var localApp = this;
        axios
          .delete("/api/wsu/" + this.$route.params.id, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          })
          .then(function(response) {
            if (response.status == 204) {
              router.push("/customerWsu");
            }
          })
          .catch(function() {
            localApp.kick();
          });
      }
    },
    getBrand: function() {
      var localApp = this;
      axios
        .get("/api/master/brand", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterBrand = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getAgent: function() {
      var localApp = this;
      axios
        .get("/api/master/agent", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterAgent = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getProvince: function() {
      var localApp = this;
      axios
        .get("/api/master/province", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterProvince = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getCarType: function() {
      var localApp = this;
      axios
        .get("/api/master/carType", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterCarType = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getBodyType: function() {
      var localApp = this;
      axios
        .get("/api/master/bodyType", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterBodyType = response.data.data.filter(
              (bodyType) => bodyType.name !== "รถยนต์นั่งเกิน 7 ที่นั่ง"
            );
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getCompany: function() {
      var localApp = this;
      axios
        .get("/api/master/company", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterCompany = response.data.data.filter(
              (company) => company.nickname !== "UPP"
            );
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    selectAgent: function(id, index) {
      var localApp = this;
      localApp.selectedAgent = index;
      localApp.model.agent = id;
    },
    selectLicensePlateProvince: function(id, index) {
      var localApp = this;
      localApp.selectedLicensePlateProvince = index;
      localApp.model.license_plate_province = id;
    },
    selectProvince: function(id, index) {
      var localApp = this;
      localApp.selectedProvince = index;
      // localApp.model.province = id;

      if(!localApp.isFirstTimeLoadProvince){
        localApp.model.district = { id: -1, name: "-" };
        localApp.model.sub_district = { id: -1, name: "-" };
        localApp.model.postal_code = "";
      }

      axios
        .get("/api/master/district/" + id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterDistrict = response.data.data;

            localApp.selectedDistrict = localApp.masterDistrict.findIndex(
              (item) => item.id === localApp.model.district
            );

            // localApp.selectDistrict(
            //   localApp.model.district,
            //   localApp.selectedDistrict
            // );
          }
          localApp.isFirstTimeLoadProvince = false;
        })
        .catch(function() {
          localApp.kick();
        });
    },
    selectDistrict: function(id, index) {
      var localApp = this;
      localApp.selectedDistrict = index;
      // localApp.model.district = id;

      if(!localApp.isFirstTimeLoadDistrict){
          localApp.model.sub_district = { id: -1, name: "-" };
          localApp.model.postal_code = "";
      }

      axios
        .get("/api/master/subdistrict/" + id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterSubDistrict = response.data.data;

            localApp.selectedSubDistrict = localApp.masterSubDistrict.findIndex(
              (item) => item.id === localApp.model.sub_district
            );
          }
          localApp.isFirstTimeLoadDistrict = false;
        })
        .catch(function() {
          localApp.kick();
        });
    },
    selectSubDistrict: function(id, index) {
      var localApp = this;
      localApp.selectedSubDistrict = index;
      // localApp.model.sub_district = id;

      if(!localApp.isFirstTimeLoadSubDistrict){
          localApp.model.postal_code = "";
      }

      axios
        .get("/api/master/postal/" + id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.model.postal_code = response.data.data[0].code;
          }
          localApp.isFirstTimeLoadSubDistrict = false;
        })
        .catch(function() {
          // localApp.kick();
          localApp.isFirstTimeLoadSubDistrict = false;

        });
    },
    selectBrand: function(id, index) {
      var localApp = this;
      localApp.selectedBrand = index;
      localApp.model.brand = id;
    },
    selectBodyType: function(id, index) {
      var localApp = this;
      localApp.selectedBodyType = index;
      localApp.model.body_type = id;
    },
    selectCarType: function(id, index) {
      var localApp = this;
      localApp.selectedCarType = index;
      localApp.model.car_type = id;
    },
    selectCompany: function(id, index) {
      var localApp = this;
      localApp.selectedCompany = index;
      localApp.model.company_id = id;
    },
    do: async function() {
      // await Promise.all([
      //   this.getProvince(),
      //   this.getBrand(),
      //   this.getCarType(),
      //   this.getBodyType(),
      //   this.getAgent(),
      //   this.getCompany(),
      // ]);
      await this.getProvince();
      await this.getBrand();
      await this.getCarType();
      await this.getBodyType();
      await this.getAgent();
      await this.getCompany();

      this.loadWSU();
    },
  },
  computed: {
    calculateDateDiff() {
      if (this.model.cover_end_date !== "") {
        let timeDiff = Math.abs(
          moment(this.model.cover_start_date, "YYYY-MM-DD HH:MM:SS") -
            moment(this.model.cover_end_date, "YYYY-MM-DD HH:MM:SS")
        );
        let dateDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return dateDiff;
      } else return "";
    },
    formattedStartContactDate: {
      get: function() {
        return this.date1;
      },
      set: function(newValue) {
        let isFirstSlashSet = false;
        let isSecondSlashSet = false;

        if (newValue.length > 10) {
          this.model.contact_start_date = newValue.substr(0, 10);
        } else {
          if (newValue.length === 2 && !isFirstSlashSet) {
            isFirstSlashSet = true;
            newValue += "/";
          }
          if (newValue.length === 5 && !isSecondSlashSet) {
            isSecondSlashSet = true;
            newValue += "/";
          }
          if (newValue.length === 6) {
            isSecondSlashSet = false;
            isSecondSlashSet = false;
          }
          this.date1 = newValue;
          this.model.contact_start_date = moment(newValue, "DD/MM/YYYY")
            .add(-543, "y")
            .format("YYYY-MM-DD HH:MM:SS");
        }
      },
    },
    formattedStartCoverDate: {
      get: function() {
        return this.date2;
      },
      set: function(newValue) {
        let isFirstSlashSet2 = false;
        let isSecondSlashSet2 = false;

        if (newValue.length > 10) {
          this.model.cover_start_date = newValue.substr(0, 10);
        } else {
          if (newValue.length === 2 && !isFirstSlashSet2) {
            isFirstSlashSet2 = true;
            newValue += "/";
          }
          if (newValue.length === 5 && !isSecondSlashSet2) {
            isSecondSlashSet2 = true;
            newValue += "/";
          }
          if (newValue.length === 6) {
            isSecondSlashSet2 = false;
            isSecondSlashSet2 = false;
          }
          this.date2 = newValue;
          this.model.cover_start_date = moment(newValue, "DD/MM/YYYY")
            .add(-543, "y")
            .format("YYYY-MM-DD HH:MM:SS");
        }
      },
    },
    formattedEndCoverDate: {
      get: function() {
        return this.date3;
      },
      set: function(newValue) {
        let isFirstSlashSet3 = false;
        let isSecondSlashSet3 = false;

        if (newValue.length > 10) {
          this.model.cover_end_date = newValue.substr(0, 10);
        } else {
          if (newValue.length === 2 && !isFirstSlashSet3) {
            isFirstSlashSet3 = true;
            newValue += "/";
          }
          if (newValue.length === 5 && !isSecondSlashSet3) {
            isSecondSlashSet3 = true;
            newValue += "/";
          }
          if (newValue.length === 6) {
            isSecondSlashSet3 = false;
            isSecondSlashSet3 = false;
          }
          this.date3 = newValue;
          this.model.cover_end_date = moment(newValue, "DD/MM/YYYY")
            .add(-543, "y")
            .format("YYYY-MM-DD HH:MM:SS");
        }
      },
    },
    formattedTaxDueDate: {
      get: function() {
        return this.date4;
      },
      set: function(newValue) {
        let isFirstSlashSet4 = false;
        let isSecondSlashSet4 = false;

        if (newValue.length > 10) {
          this.model.tax_due_date = newValue.substr(0, 10);
        } else {
          if (newValue.length === 2 && !isFirstSlashSet4) {
            isFirstSlashSet4 = true;
            newValue += "/";
          }
          if (newValue.length === 5 && !isSecondSlashSet4) {
            isSecondSlashSet4 = true;
            newValue += "/";
          }
          if (newValue.length === 6) {
            isSecondSlashSet4 = false;
            isSecondSlashSet4 = false;
          }
          this.date4 = newValue;
          this.model.tax_due_date = moment(newValue, "DD/MM/YYYY")
            .add(-543, "y")
            .format("YYYY-MM-DD HH:MM:SS");
        }
      },
    },
  },
    watch: {
    "model.province": function(newVal) {
      this.selectProvince(newVal, -1);
    },
    "model.district": function(newVal) {
      this.selectDistrict(newVal, -1);
    },
    "model.sub_district": function(newVal) {
      this.selectSubDistrict(newVal, -1);
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.do();
      this.lvl = localStorage.level;
    }
  },
};
</script>
<style>
h4 {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}
.date-picker div input {
  color: #8898aa;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  display: block;
  background-color: #fff;
  font-weight: 400;
  background-clip: padding-box;
  font-size: 0.875rem;
  margin: 0;
  padding: 0.625rem 0.75rem;
  border: 0;
  font-family: inherit;
  border-radius: 0.375rem;
  transition: box-shadow 0.15s ease, -webkit-box-shadow 0.15s ease;
  cursor: pointer;
}
.dropdown-menu {
  max-height: 300px !important;
  overflow-y: auto;
}
label,
.form-control,
.btn {
  font-size: 1rem !important;
}

h3 {
  font-size: 1.2rem;
}
</style>
